import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_PROVINCE',
};

export const listProvinces = () => ({
  type: ACTION.LIST,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_PROVINCE,
    params: {
      limit: 100,
    },
  })
    .then(resp => resp.data)
    .catch(err => Promise.reject((err.response && err.response.data && err.response.data.detail) || err.message)),
});

export const searchProvinceByText = (text, page = 0) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  return RestClient.request({
    method: 'get',
    url: Constants.API_PROVINCE,
    params: {
      search: text,
      limit: pageSize,
      offset: page * pageSize,
    },
  });
};



// WEBPACK FOOTER //
// ./src/redux/provinces/province_actions.js